import { useEffect } from "react";
import { storeLogoQuery } from "../../graphql/storeLogo.gql";
import IconIconMenu from "../icons/IconIconMenu";
import ActionIcons from "./ActionIcons";
import BottomNavbar from "./BottomNavbar";
import HeaderLogo from "./HeaderLogo";

export default function MobileNavbar({ storeLogo }: storeLogoQuery) {
  return (
    <div className="fixed top-0 right-0 w-screen h-[50px] shadow-md bg-white flex 992:hidden justify-between items-center p-3 box-border z-30">
      <div className="flex flex-row justify-start">
        <div>
          <IconIconMenu width={38} height={38} className="text-default-800 cursor-pointer" id="openMobileMenu" />
          <div className="hidden opacity-0 opa fixed top-0 right-0 left-0 bottom-0 bg-black/20 z-50" id="menuBackDrop" />
        </div>
        <HeaderLogo storeLogo={storeLogo} />
      </div>
      <div className="flex justify-end items-center gap-2">
        <ActionIcons />
        {/* <Scripts /> */}
      </div>
    </div>
  )
}





